var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold, adaptive: _vm.adaptive }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }